import React from 'react';
import { Stack } from '@mui/material';

// Components
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import ImportOriginTable from 'src/features/PortDetail/TradeTransit/ImportOriginTable';
import ExportDestinationTable from 'src/features/PortDetail/TradeTransit/ExportDestinationTable';
import FreightRateTable from 'src/features/PortDetail/TradeTransit/FreightRateTable';

// Utilities
import { ITradePortDetailInfo } from 'src/utils/typings/response';
import TransitTradeTable from 'src/features/PortDetail/TradeTransit/TransitTradeTable';

interface IProps {
  portDetail: ITradePortDetailInfo | null;
}

const TradeTransitTab = ({ portDetail }: IProps) => {
  return (
    <React.Fragment>
      <Stack direction="column" spacing={3}>
        <Stack direction="row" spacing={2}>
          <ImportOriginTable
            listTopPartner={getArrayDefault(portDetail?.top_partners?.origin)}
            listTopCountryPartner={getArrayDefault(portDetail?.top_country_partners?.origin)}
            period={{
              port: portDetail?.top_partners?.period || '',
              country: portDetail?.top_country_partners?.period || '',
            }}
          />
          <ExportDestinationTable
            listTopPartner={getArrayDefault(portDetail?.top_partners?.destination)}
            listTopCountryPartner={getArrayDefault(portDetail?.top_country_partners?.destination)}
            period={{
              port: portDetail?.top_partners?.period || '',
              country: portDetail?.top_country_partners?.period || '',
            }}
          />
        </Stack>
        <FreightRateTable listAllFreightRate={getArrayDefault(portDetail?.freight_rates)} />
        <TransitTradeTable locode={portDetail?.meta?.locode || ''} />
      </Stack>
    </React.Fragment>
  );
};

export default TradeTransitTab;
